import ReactCodeInput from 'react-code-input'
import React from 'react'
import cx from 'classnames'
import styles from '../Input/Input.module.css'

const CodeInput: React.FC<{
    property: string
    value: string
    style?: React.CSSProperties
    classes?: string
    label: string
    onChange: (property: string, value: string) => void
}> = ({ label, property, value, style, classes, onChange }) => {
    const inputChange = (value: string) => {
        onChange(property, value)
    }

    const inputStyle: React.CSSProperties = {
        fontFamily: 'NunitoSans',
        fontSize: '1rem',
        padding: '7px 14px',
        margin: '0 0.5rem',
        borderRadius: '0',
        border: '1px solid #ccc',
        outline: 'none',
        backgroundColor: '#fff !important',
    }

    return (
        <div
            className={cx(styles['zr-input-container'], classes)}
            style={style}
        >
            <label style={{ fontSize: '0.75rem' }}>{label}</label>
            <div
                className={'test'}
                style={{ marginLeft: '-0.5rem', marginTop: '-0.75rem' }}
            >
                <ReactCodeInput
                    type="number"
                    fields={6}
                    inputMode={'numeric'}
                    name={property}
                    value={value}
                    onChange={inputChange}
                    inputStyle={inputStyle}
                />
            </div>
        </div>
    )
}

export default CodeInput
